import { createFileRoute } from '@tanstack/react-router';
import OrdersManagement from '../../../components/manager/OrdersManagement';

export const Route = createFileRoute('/manager/orders/')({
  component: ManagerOrdersIndex,
});

function ManagerOrdersIndex() {
  return <OrdersManagement />;
}
